module.exports = __webpack_public_path__ + "website/img/core1_3.a5ac0193.png";